import React from 'react'

import { Container } from './styles'

const Action: React.FC = ({ children }) => {
  return <Container>{children}</Container>
}

export default Action
